import { render, staticRenderFns } from "./CategorizedProduct.vue?vue&type=template&id=b32b0004&"
import script from "./CategorizedProduct.vue?vue&type=script&lang=js&"
export * from "./CategorizedProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports